"use strict";

const HardAssetAssociatedProject = function () {
  var getSelectedProject = function (selectedProjectId) {
    if (!selectedProjectId) {
      return null;
    }

    const project = HardAssetInventoryModalController.getLatestData(
      "possibleAssociatedProjects",
    ).find((project) => project.id === parseInt(selectedProjectId));

    if (project === undefined) {
      throw new Error(
        `Couldn't find project with id ${selectedProjectId} in possibleAssociatedProjects.`,
      );
    }

    return project;
  };

  var applyProjectToInventory = function (selectedProjectId) {
    const project = getSelectedProject(selectedProjectId);

    if (!project) {
      return;
    }

    setUnlessEmpty(
      "phase",
      HardAssetInventoryConfig.getAssetPhase(
        HardAssetInventoryModalController.getAssetType(),
        project.linkedAssetPhase,
      ),
    );
    setUnlessEmpty("responsiblePartyDelivery", project.responsiblePartyDelivery);
    setUnlessEmpty("responsiblePartyMaintenance", project.responsiblePartyMaintenance);

    if (HardAssetInventoryConfig.phaseHasInstallDate(project.linkedAssetPhase)) {
      setUnlessEmpty("installDate", project.endDate);
    }
  };

  var setUnlessEmpty = function (field, value) {
    if (value !== null && value !== undefined) {
      HardAssetInventoryModalController.setFormDataField(field, value);
    }
  };

  var getCurrentProject = function () {
    return getSelectedProject(HardAssetInventoryModalController.getLatestData("associatedProject"));
  };

  var isPhaseLockedByProject = function () {
    return getCurrentProject() !== null;
  };

  return {
    getSelectedProject,
    applyProjectToInventory,
    isPhaseLockedByProject,
  };
};

module.exports = HardAssetAssociatedProject();

const HardAssetInventoryConfig = require("./hardAssetInventoryConfig");
const HardAssetInventoryModalController = require("../hardAssetInventoryModalController");
